export const removeFalsy = <A>(arr: (A | null | undefined | false | '' | 0)[]): NonNullable<A>[] => {
  return arr.filter(e => !!e) as any
}
